import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'
import { PIPELINE_QUERY_KEY } from './useGetPipeline'

type PipelineQualityPayload = {
  consensus: boolean
  minMS?: number
  consensusType?: string
  weightedConsensusThreshold?: number
  featureWeights?: {
    featureId: string
    weight: number
  }[]
}

export const useEditQuality = (jobId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (payload: PipelineQualityPayload) => {
      const { data } = await apiClient.put(`/int/v3/programs/pipeline/jobs/${jobId}/quality`, payload)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PIPELINE_QUERY_KEY] })
    },
  })
}
